module.exports = __webpack_public_path__ + "img/candidates.2e3aa1eb.svg";